import { FileDownload } from '@mui/icons-material';
import LoadingButton from '@mui/lab/LoadingButton';
import { PDFDownloadLink } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import {
  InvoiceManagementInvoicePdfDocument,
  type InvoiceManagementInvoicePdfData,
} from './InvoiceManagementInvoicePdfDocument';

type InvoiceManagementInvoiceDownloadButtonProps = {
  data: InvoiceManagementInvoicePdfData | null;
};

export const InvoiceManagementInvoiceDownloadButton = ({ data }: InvoiceManagementInvoiceDownloadButtonProps) => {
  const { t } = useTranslation();

  if (!data) {
    return null;
  }

  return (
    <PDFDownloadLink
      document={<InvoiceManagementInvoicePdfDocument data={data} />}
      fileName={`upominej-faktura-${data.number}.pdf`}
    >
      {({ loading }) => (
        <LoadingButton startIcon={<FileDownload />} variant="outlined" loading={loading}>
          {t('invoice.download')}
        </LoadingButton>
      )}
    </PDFDownloadLink>
  );
};
